module.exports = __webpack_public_path__ + "img/express-gray.a9737d94.svg";